import * as types from './project-time.types';
import * as constants from './project-time.constants';
import { generateClearResourceAction, generateStoreResourceAction } from '../generators/resource.actions';

export const storeProjectTime = generateStoreResourceAction<types.IProjectTasksTime>(constants.STORE_PROJECT_TIME);
export const clearProjectTime = generateClearResourceAction(constants.CLEAR_PROJECT_TIME);
